<template>
  <div class="main-cont">

	<br><br>
    <h1 class="header-desc">CONOCE AL EQUIPO DE ELECTCHAIN.IO</h1>
	<div class="wrapper-team">
		<TeamCard v-for="i in team_img" :key="i.n" :photo="i.s" :name="i.n" :email="i.m" :desca="i.a" :descb="i.b" :descc="i.c"/>
	</div>
		
	<br>
	<h1 class="header-desc">MANTENTE ACTUALIZADO</h1>
	<div>
		<a v-for="i in icon_img" :data="i.s" :key="i.alt" :href="i.ref">
			<img class="social" :src="i.s" :alt="i.alt">
		</a>
	</div>

	<br>
	<h1 class="header-desc">¿QUÉ DICEN LOS MEDIOS?</h1>
	<div class="media-train">
		<a class="media-cont" v-for="i in media_advise" :data="i.s" :key="i.alt" :href="i.ref">
			<div>
				<img class="media-image" :src="i.s">
				<hr>
				<div>{{ i.alt }}</div>
			</div>
		</a>
	</div>

	<br>
	<h1 class="header-desc">COMUNICATE CON NOSOTROS</h1>
	<a :href="icon_img[0].ref">
		<img class="social" style="margin: 0px;" :src="icon_img[0].s" :alt="icon_img[0].alt">
		<p>electchain.io@gmail.com</p>
	</a>

	<br>
	<h1 class="header-desc">¿DESEEAS APOYAR LA INICIATIVA?</h1>
	<a :href="ieth.ref">
		<img class="social" style="margin: 0px;" :src="ieth.s" :alt="ieth.alt">
		<p>{{ ieth.alt }}</p>
	</a>

		<div class="end">
			<hr>
			<div class="credits">
				<span>{{ disc }}</span>
				<br>
				<span>{{ foot }}</span>
				<br>
				<span>{{ cred }}</span>
			</div>
  	</div>

  </div>
</template>

<script>
import TeamCard from './TeamCard.vue';

export default {  
	components: 	{TeamCard},
  	data () {
	    return {
			team_img: [
				{ s: require('./media/am.jpg'), n: 'Alexis Contreras',  a: 'Estudiante IPN - ESCOM',	b: 'Lider del proyecto', c: 'Web, Android, Solidity', 	m: 'mailto:amichell.con@gmail.com'},
				{ s: require('./media/av.jpg'), n: 'Axel Vargas Sosa', 	a: 'Estudiante IPN - UPIITA', 	b: 'Desarrollador Web,', c: 'Desarollador de IA', 		m: 'mailto:axl.vargass@gmail.com' },
				//{ s: require('./media/cn.jpg'), n: 'Carlos R Noveron',  a: 'Estudiante IPN - ESCOM', 	b: 'Análisis y diseño',  c: 'Web3, Solidity', 			m: 'mailto:carlos.escom.ipn@gmail.com' },
				{ s: require('./media/fp.jpg'), n: 'Felipe Prieto', 	a: 'Estudiante IPN - ESCOM', 	b: 'Análisis y diseño',  c: 'Desarrollador Frontend', 	m: 'mailto:felipe00@live.com.mx' },
				{ s: require('./media/jg.jpg'), n: 'Jose M Gutierrez',  a: 'Estudiante IPN - ESCOM', 	b: 'Análisís y diseño',  c: 'Desarrollador WebApps', 	m: 'mailto:coldpcmickey@gmail.com' },
		  	],
	  		icon_img: [
				{ s: require('./assets/gm.png'), alt:'E-Mail',	 ref: 'mailto:electchain.io@gmail.com'},
				{ s: require('./assets/fb.png'), alt:'Facebook', ref: 'https://www.facebook.com/electchain/'},
				{ s: require('./assets/gh.png'), alt:'GitHub',   ref: 'https://github.com/electchain?tab=repositories'},
				{ s: require('./assets/rd.png'), alt:'Reddit',   ref: 'https://www.reddit.com/user/electchain_io'},
				{ s: require('./assets/tg.png'), alt:'Telegram', ref: 'https://t.me/electchain_io'},
				{ s: require('./assets/tw.png'), alt:'Twitter',  ref: 'https://twitter.com/electchainio'},
				{ s: require('./assets/sod.png'), alt:'State of Dapps',  ref: 'https://www.stateofthedapps.com/dapps/electchain'},
	  		],
	  		media_advise: [
		  		{s: require('./assets/idg.png'), alt: 'Reporte Indigo', ref: 'https://www.reporteindigo.com/indigonomics/blindar-las-elecciones-blockchain-herramienta-tecnologica-reduccion-costo-proceso/'},
		  		{s: require('./assets/crn.png'), alt: 'Cripto Noticias', ref: 'https://www.criptonoticias.com/votaciones/ong-simula-proximas-elecciones-presidenciales-mexico-ethereum/'},
		  		{s: require('./assets/elc.png'), alt: 'El Criptógrafo', ref: 'https://elcriptografo.com/2018/06/21/elecciones-mexico-blockchain-electchain/'},
				{s: require('./assets/elf.png'), alt: 'El Financiero', ref:'http://www.elfinanciero.com.mx/elecciones-2018/ellos-pondran-a-prueba-al-prep-con-blockchain'},
				{s: require('./assets/uno.png'), alt: 'UNOCERO', ref:'https://www.unocero.com/noticias/apps/tres-apps-ciudadanas-para-seguir-el-conteo-de-votos-estas-elecciones/'},
				{s: require('./assets/cpa.png'), alt: 'Criptopasion', ref:'https://criptopasion.com/electchain-blockchain-votaciones-mexico/'},
				{s: require('./assets/frb.png'), alt: 'Forbes México', ref:'https://www.forbes.com.mx/ia-blockchain-y-arte-para-impulsar-la-votacion/'},
				{s: require('./assets/ent.png'), alt: 'Entrepreneur ESP', ref:'https://www.entrepreneur.com/article/315963'},
	  		],
			sotd: { s: require('./assets/sod.png'), alt: 'State of the Dapps', ref: 'https://www.stateofthedapps.com/dapps/electchain'},
			ieth: { s: require('./assets/eth.png'), alt: 'Ethereum Address', ref: 'https://etherscan.io/address/0x3d056f76ac9b9d69cc3bb13d205568a1ed176388'},
			disc: 'Electchain no está apoyado por algún partido político o empresa',
	  		foot: '2017-2018 Electchain.io | Web design by: A Contreras & F Prieto | Hecho en México con ♥ y tacos',
    		cred: 'All credits goes to their respective owners | Todos los créditos, a sus respectivos propietarios'
		}
  	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-cont{
	position: relative;
}
.media-train{
	display: inline-table;
	width: 100%;
}
.media-cont{
	display: inline-flex;
	padding: 10px; 
	height: 100%;
	align-self: end;
}
a{
	text-decoration: none;
}
hr, p{
	margin: 0px;
	padding: 0px;
}
.media-image{
	max-width: 200px;
}
.wrapper-team{
	max-width: 1400px;
	display: inline-table;
 	align-items: center;
}
.social{
	margin: 20px;
 	max-width:  48px;
 	max-height: 48px;
}
.social-icon{
	 display: inline-flex;
}
.tech-icon{
  display: flex;
  flex-direction: row;
  min-height: 320px;
}
.end{
	position:absolute;
	bottom: 0;
	width: 100%;
}
.credits{
	padding: 10px;
}

@media only screen and (max-width: 480px){
  img{
    max-width:  48px;
    max-height: 48px;
  }
  .media-train{
	background: #2d598b;
	display: flex;
	flex-direction: column;
	width: 100%;
  }
  .media-cont{
    align-self: unset;
  }
 .social-icon{
  display: inline-flex;
 }
 .tech-icon{
   display: flex;
   flex-direction: row;
   min-height: 320px;
 }
 .credits{
  display: inline-table;
  padding: 10px;
 }
}
</style>



// WEBPACK FOOTER //
// src/components/Team.vue